import NavBarContainer from './containers/NavBarContainer';

export default NavBarContainer;
